import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { useNotification } from 'utils/hooks/useNotification';
import { createWorkflow } from '../DroppableCanvas/workflowsService';
import { workflowAtom } from '../atoms';

export const useSaveWorkflow = () => {
  const workflow = useAtomValue(workflowAtom);
  const navigate = useNavigate();
  const { showSuccessNotification, showErrorNotification } = useNotification();

  const {
    mutate: saveWorkflow,
    isPending: isLoading,
    isError,
    isSuccess,
    error,
  } = useMutation({
    mutationFn: () => createWorkflow(workflow),
    onError: (mutationError: AxiosError<string>) => {
      const errorMessage =
        mutationError?.response?.data ||
        mutationError?.message ||
        'An unknown error occurred';

      showErrorNotification(`Failed to save workflow: ${errorMessage}`);
    },
    onSuccess: () => {
      showSuccessNotification('Workflow saved successfully');
      navigate('/run-orchestrations');
    },
  });

  return {
    error,
    isError,
    isLoading,
    isSuccess,
    saveWorkflow,
  };
};
